import React, { Component } from 'react';
import styles from './Messages.module.css';
import {connect} from 'react-redux';
import axios from 'axios';
import {Link, Route} from 'react-router-dom';
import MessageBox from './Message-box/MessageBox';
import noUser from '../../assets/no_user.jpg';
import firebase from '../../firebase';

class Messages extends Component {

    state = {
        messages: [],
        users:{}
    }
    
    componentDidMount() {
        if(!this.props.loginStatus.isLoggedIn) {
            this.props.history.replace({pathname: '/'});
        }

        axios.get('/users.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            this.setState({users: response.data});
        });

        firebase.database().ref('messages/' + this.props.loginStatus.userId)
        .on('value', (snapShot)=>{
            const data = snapShot.val();
            delete data.dummyUser;
            const messages = [];
            Object.keys(data).map(userId => {
                messages.push({[userId]: data[userId]});
            });
            messages.sort(this.sort);
            this.setState({messages: messages});
        });
    
    }

    componentDidUpdate() {
        if(!this.props.loginStatus.isLoggedIn) {
            this.props.history.replace({pathname: '/'});
        }
    }

    sort = (el1, el2) => {
        el1 = el1[Object.keys(el1)[0]];
        el2 = el2[Object.keys(el2)[0]];
        return new Date(el1[el1.length-1].timestamp) > new Date(el2[el2.length-1].timestamp) ? -1 : 1;
    }
    getTimeStamp = (date) => {
         date = new Date(date);
        if((new Date().getTime() - date.getTime()) / 3600000 > 24)
        return date.toLocaleDateString();
        else return this.formatTime(date)
    }

    formatTime = (date) => {
        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    render() {
        return(
            <div className={styles.main}>
                <div className={styles.container}>
                <div className={styles.messages}>
                    <div className={styles.header}>
                        Messages
                    </div>
                    <div className={styles.body}>
                        {this.state.messages.length === 0 ?
                        <div className={styles.noMsg}>You don't have any messages</div> : null
                        }
                    {this.state.messages.map(msgObj => {
                        let userId = Object.keys(msgObj)[0];
                        let messagesData = msgObj[userId];
                    return (
                       <div className={[styles.user, messagesData[messagesData.length - 1].status?'':styles.unread].join(' ')} key={userId}>
                        <div className={styles.dp}>
                            <Link to={'/account/' + userId}>
                            <img src={this.state.users[userId] ? this.state.users[userId].profilePic : noUser} 
                            width="50" height="50" alt='profile pic'/> 
                            </Link>
                         <span className={styles.time}>
                             {this.getTimeStamp(messagesData[messagesData.length-1].timestamp)}
                         </span>
                        </div>
                        <div className={styles.details}>
                            <Link to={'/messages/'+ userId}>
                            <div className={styles.name}>
                                <h2>{this.state.users[userId]?.name}</h2>
                                {this.state.users[userId]?.isVerified ?
                                  <span style={{marginLeft:'5px'}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16px" height="16px">
                                    <polygon fill="#42a5f5" points="29.62,3 33.053,8.308 39.367,8.624 39.686,14.937 44.997,
                                    18.367 42.116,23.995 45,29.62 39.692,33.053 39.376,39.367 33.063,39.686 29.633,44.997 24.005,
                                    42.116 18.38,45 14.947,39.692 8.633,39.376 8.314,33.063 3.003,29.633 5.884,24.005 3,18.38 8.308,
                                    14.947 8.624,8.633 14.937,8.314 18.367,3.003 23.995,5.884"/>
                                    <polygon fill="#fff" points="21.396,31.255 14.899,24.76 17.021,22.639 21.428,27.046 30.996,
                                    17.772 33.084,19.926"/>
                                    </svg>
                                  </span>
                                  : null
                                } 
                             </div>
                             <div className={styles.messagePreview}>
                                 {messagesData[messagesData.length - 1].message.slice(0, 30) +
                                 (messagesData[messagesData.length - 1].message.length >= 30 ? '...' : '')}
                             </div>
                             </Link>
                        </div>
                     </div>
                    )})}
                    </div>
                </div>
                 <Route path="/messages/:userId"  render={(props)=><MessageBox users={this.state.users} {...props} />} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus
    }
}
export default connect(mapStateToProps)(Messages);